import React from 'react';
import './OdTips.scss';

const OdTips = ({ data }) => {
  const { title, cta, tips, ctaLink } = data;
  return (
    <div className="odtips">
      <div className="odtips-header">
        <div className="odtips-header-title">{title}</div>
        <a className="odtips-header-more od_link" href={ctaLink}>
          {cta}
        </a>
      </div>
      <div className="odtips-cards">
        {tips?.map(tip => (
          <a
            key={tip.label}
            className="odtips-cards-item od_link"
            href={tip.link}
            style={{ backgroundImage: `url(${tip.imgSrc})` }}
          >
            <div className="odtips-cards-item-label">{tip.label}</div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default OdTips;
